import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

/** Bloque colapsable «Detalles técnicos» para ids y datos de infraestructura; arranca cerrado. */
export function TechnicalDetails({ children }: { children: ReactNode }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-lg border bg-muted/30">
            <button
                type="button"
                aria-expanded={open}
                className="flex w-full items-center justify-between px-4 py-3 text-sm font-semibold text-muted-foreground hover:text-foreground"
                onClick={() => {
                    setOpen((v) => !v);
                }}
            >
                Detalles técnicos
                <ChevronDown
                    className={`size-4 transition-transform ${open ? 'rotate-180' : ''}`}
                />
            </button>
            {open && <div className="space-y-3 border-t px-4 py-4">{children}</div>}
        </div>
    );
}
